import AxiosConfig from '../../../config/AxiosConfig';
import { normalizeMatchingInternalProducts } from './normalizeMatchingInternalProducts';

const useGetMatchingInternalProducts = () => {
  const getMatchingProducts = async (searchIndex) => {
    try {
      const response = await AxiosConfig.create(
        'get',
        `/savdraft/matchingInternalProducts/${encodeURIComponent(searchIndex)}`
      )
        .call()
        .getResponseData();

      return normalizeMatchingInternalProducts(response);
    } catch (err) {
      console.error('Failed to fetch matching products:', err);
      throw new Error(`Products fetch failed: ${err.message}`);
    }
  };

  return {
    getMatchingProducts,
  };
};

export default useGetMatchingInternalProducts;
